import { useState } from "react";
import {
  Button,
  Form,
  Header,
  Icon,
  Input,
  Modal,
  ModalActions,
  ModalContent,
} from "semantic-ui-react";
import { useSetupIpecsManager } from "../../hooks/useSetupIpecsManager";
import { style } from "../../style";
import { Field } from "../ui";

const SendToIpecsModal = ({
  disabled,
  mohConfigured,
  uploading,
  onConfirmExisting,
  onCredentialsSaved,
}) => {
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState({
    url: "",
    username: "",
    password: "",
  });

  const { setupIpecsManagerMutate, formErrors, isLoading, resetForm } =
    useSetupIpecsManager(() => onCredentialsSaved());

  const busy = isLoading || uploading;

  const handleClose = () => {
    if (busy) return;
    setOpen(false);
    setDetails({ url: "", username: "", password: "" });
    resetForm();
  };

  const handleSubmit = () => {
    setupIpecsManagerMutate(details);
  };

  const handleConfirmExisting = () => {
    onConfirmExisting();
    handleClose();
  };

  return (
    <>
      <Button
        disabled={disabled}
        loading={uploading}
        onClick={() => setOpen(true)}
        style={style.accentButton}
        labelPosition="left"
        icon
      >
        <Icon name="upload" />
        Send to iPECS
      </Button>
      <Modal centered={false} closeIcon onClose={handleClose} open={open}>
        <Header>Send to iPECS</Header>
        <ModalContent>
          {mohConfigured ? (
            "This will override all existing hold music on your iPECS system, are you sure?"
          ) : (
            <>
              <p>
                We need your iPECS manager credentials before we can upload your
                music on hold.
              </p>
              <Form onSubmit={handleSubmit}>
                <Field
                  variant="form"
                  label="iPECS Manager URL"
                  error={formErrors?.url}
                >
                  <Input
                    value={details.url}
                    disabled={busy}
                    onChange={(e, { value }) =>
                      setDetails({ ...details, url: value })
                    }
                  />
                </Field>
                <Field
                  variant="form"
                  label="Username"
                  error={formErrors?.username}
                >
                  <Input
                    value={details.username}
                    disabled={busy}
                    onChange={(e, { value }) =>
                      setDetails({ ...details, username: value })
                    }
                  />
                </Field>
                <Field
                  variant="form"
                  label="Password"
                  error={formErrors?.password}
                >
                  <Input
                    type="password"
                    value={details.password}
                    disabled={busy}
                    onChange={(e, { value }) =>
                      setDetails({ ...details, password: value })
                    }
                  />
                </Field>
              </Form>
            </>
          )}
        </ModalContent>
        <ModalActions>
          <Button
            disabled={busy}
            loading={busy}
            onClick={mohConfigured ? handleConfirmExisting : handleSubmit}
            style={style.accentButton}
            labelPosition="left"
            icon
          >
            <Icon name="upload" />
            {mohConfigured ? "Confirm" : "Save"}
          </Button>
        </ModalActions>
      </Modal>
    </>
  );
};

export default SendToIpecsModal;
